var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 'ExodusModel')?_c('div',[_c('exodus-model',{attrs:{"model":_vm.model}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }